import './Funnel.css';
import React, { Component, useRef } from 'react';
import emailjs from 'emailjs-com';

import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea, CardHeader } from '@mui/material';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';


//Images
import bg from './Media/Images/bg.png';
import fd from './Media/Images/fd.png';
import sd from './Media/Images/Satteldach-2.png';
import pd from './Media/Images/pd.png';
import qm from './Media/Images/fragezeichen.png';
import grad0 from './Media/Images/0.png';
import grad5 from './Media/Images/5.png';
import grad30 from './Media/Images/30.png';
import grad45 from './Media/Images/45.png';
import klein from './Media/Images/klein.png';
import mittel from './Media/Images/mittel.png';
import gross from './Media/Images/groß.png';
import riesig from './Media/Images/riesig.png';
import dachrinne from './Media/Images/Dachrinne.png';
import freispi from './Media/Images/Dachrinne-2.png';
import kies from './Media/Images/Dachrinne-4.png';
import okies from './Media/Images/Dachrinne-3.png';




//Icons
import LocalFloristSharpIcon from '@mui/icons-material/LocalFloristSharp';
import CakeIcon from '@mui/icons-material/Cake';
import CelebrationIcon from '@mui/icons-material/Celebration';
import LiquorIcon from '@mui/icons-material/Liquor';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

class AnfrageDto {
  constructor() {
    this.vorname = "";
    this.nachname = "";
    this.telefon = "";
    this.email = "";
    this.plz = "";
    this.dachform = "";
    this.dachneigung = "";
    this.flachengrosse = "";
    this.entwasserung = "";
    this.kiesstreifen = "";
  }

}

class Funnel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      //Properties
      //Bsp: buttonLvl1Text: this.props.buttonLvl1Text,
      needCard: this.props.needCard,
      anzahlCards: this.props.anzahlCards,
      frage: this.props.frage,
      pageZähler: 0,
      count: 0,
      Vorname: "",
      Nachname: "",
      Email: "",
      Telefon: "",
    }
    //Muss rein, damit die Funktionen eingebunden werden können
    //this.addCart = this.addCart.bind(this)
    this.anfrageDto = new AnfrageDto;
    this.erstelleCards = this.erstelleCards.bind(this);
    
  }
  /*Properties
    bool needCard
    int anzahlCards
    string frage‚
  */
  answer = []
  //Hier die Funktionen
  handleChange = (e) => {
    this.setState({ value: e.target.value });
  };

  sendEmail(vorname, nachname, telefon, email, plz, dachform, dachneigung, flachengrosse, entwasserung, kiesstreifen) {

    var templateParams = {
      vorname: vorname,
      nachname: nachname,
      telefon: telefon,
      email: email,
      plz: plz,
      dachform: dachform,
      dachneigung: dachneigung,
      flachengrosse: flachengrosse,
      entwasserung: entwasserung,
      kiesstreifen: kiesstreifen
    };

    emailjs.send('service_ocok9qy', 'template_15m30pq', templateParams, 'jnmW59eajg708njcI')
      .then(function (response) {
        console.log('SUCCESS!', response.status, response.text);
      }, function (error) {
        console.log('FAILED...', error);
      });
  }

  erstelleCards() {
    if (this.props.needCard) {
      for (let i = 0; i < this.props.anzahlCards; i++) {

      }
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };

  increase() {
    this.setState({ count: this.state.count + 1 });
    this.scrollToTop();
  }

  decrease() {
    this.setState({ count: this.state.count - 1 });
    this.scrollToTop();
  }

  

  render() {
    const getForm = (site) => {
      switch (site) {
        case 0:
          return (
            <div className='MainDiv' >
              <div>
                <div className='QuestDiv'>
                  <h1>Welche Dachform haben Sie?</h1>
                </div>
                <div className='FlexDiv'>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.dachform = "Flachdach";
                    this.increase();
                  }}>


                    <CardActionArea>

                      <CardContent>
                        <CardMedia
                          component="img"
                          image={fd}
                          alt="Paella dish"
                        />
                        <Typography gutterBottom variant="h5" component="div">
                          Flachdach
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.dachform = "Satteldach";
                    this.increase();
                  }}>
                    <CardActionArea>

                      <CardContent>
                        <CardMedia
                          component="img"
                          image={sd}
                          alt="Paella dish"
                        />
                        <Typography gutterBottom variant="h5" component="div">
                          Satteldach
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.dachform = "Pultdach";
                    this.increase();
                  }}>
                    <CardActionArea>
                      <CardContent>
                        <CardMedia
                          component="img"
                          image={pd}
                          alt="Paella dish"
                        />
                        <Typography gutterBottom variant="h5" component="div">
                          Pultdach
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.dachform = "Sonstiges";
                    this.increase();
                  }}>
                    <CardActionArea>
                      <CardContent>
                        <CardMedia
                          component="img"
                          image={qm}
                          alt="Paella dish"
                        />
                        <Typography gutterBottom variant="h5" component="div">
                          Sonstiges
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </div>
              </div>
            </div>)
          break;
        case 1:
          return (
            <div className='MainDiv' >
              <div>
                <div className='QuestDiv'>
                  <h1>Wie viel Neigung hat Ihr Dach?</h1>
                </div>
                <div className='FlexDiv'>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.dachneigung = "0-5°";
                    this.increase();
                  }}>
                    <CardActionArea>

                      <CardContent>
                        <CardMedia
                          component="img"
                          image={grad0}
                          alt="Paella dish"
                        />
                        <Typography gutterBottom variant="h5" component="div">
                          0°-5°
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.dachneigung = "5°-15°";
                    this.increase();
                  }}>
                    <CardActionArea>
                      <CardContent>
                        <CardMedia
                          component="img"
                          image={grad5}
                          alt="Paella dish"
                        />
                        <Typography gutterBottom variant="h5" component="div">
                          5°-15°
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.dachneigung = "15°-30°";
                    this.increase();
                  }}>
                    <CardActionArea>
                      <CardContent>
                        <CardMedia
                          component="img"
                          image={grad30}
                          alt="Paella dish"
                        />
                        <Typography gutterBottom variant="h5" component="div">
                          15°-30°
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.dachneigung = "30°-45°";
                    this.increase();
                  }}>
                    <CardActionArea>
                      <CardContent>
                        <CardMedia
                          component="img"
                          image={grad45}
                          alt="Paella dish"
                        />
                        <Typography gutterBottom variant="h5" component="div">
                          30°-45°
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </div>
              </div>
            </div>)
          break;
        case 2:
          return (
            <div className='MainDiv' >
              <div>
                <div className='QuestDiv'>
                  <h1>Wie viel Fläche hat Ihr Dach?</h1>
                </div>
                <div className='FlexDiv'>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.flachengrosse = "5 - 15m2";
                    this.increase();
                  }}>
                    <CardActionArea>
                      <CardContent><CardMedia
                        component="img"
                        image={klein}
                        alt="Paella dish"
                      />
                        <Typography gutterBottom variant="h5" component="div">
                          5m² - 15m²
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.flachengrosse = "15-30m2";
                    this.increase();
                  }}>
                    <CardActionArea>
                      <CardContent>
                        <CardMedia
                          component="img"
                          image={mittel}
                          alt="Paella dish"
                        />
                        <Typography gutterBottom variant="h5" component="div">
                          15m² - 30m²
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.flachengrosse = "30-100m2";
                    this.increase();
                  }}>
                    <CardActionArea>
                      <CardContent>
                        <CardMedia
                          component="img"
                          image={gross}
                          alt="Paella dish"
                        />
                        <Typography gutterBottom variant="h5" component="div">
                          30m² - 100m²
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.flachengrosse = ">100m2";
                    this.increase();
                  }}>
                    <CardActionArea>
                      <CardContent>
                        <CardMedia
                          component="img"
                          image={riesig}
                          alt="Paella dish"
                        />
                        <Typography gutterBottom variant="h5" component="div">
                          mehr als 100m²
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </div>
              </div>
            </div>)
          break;
        case 3:
          return (
            <div className='MainDiv' >
              <div>
                <div className='QuestDiv'>
                  <h1>Wie ist Ihre Entwässerung?</h1>
                </div>
                <div className='FlexDiv'>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.entwasserung = "Rinnenenwässerung";
                    this.increase();
                  }}>
                    <CardActionArea>
                      <CardContent>
                        <CardMedia
                          component="img"
                          image={dachrinne}
                          alt="Paella dish"
                        />
                        <Typography gutterBottom variant="h5" component="div">
                          Rinnenenwässerung
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.entwasserung = "Freispiegelentwässerung";
                    this.increase();
                  }}>
                    <CardActionArea>
                      <CardContent>
                        <CardMedia
                          component="img"
                          image={freispi}
                          alt="Paella dish"
                        />
                        <Typography gutterBottom variant="h5" component="div">
                          Freispiegelentwässerung
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.entwasserung = "Druckentwässerung";
                    this.increase();
                  }}>
                    <CardActionArea>
                      <CardContent>
                        <CardMedia
                          component="img"
                          image={freispi}
                          alt="Paella dish"
                        />
                        <Typography gutterBottom variant="h5" component="div">
                          Druckentwässerung
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.entwasserung = "Sonstiges";
                    this.increase();
                  }}>
                    <CardActionArea>
                      <CardContent>
                        <CardMedia
                          component="img"
                          image={qm}
                          alt="Paella dish"
                        />
                        <Typography gutterBottom variant="h5" component="div">
                          Sonstiges
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </div>
              </div>
            </div>)
          break;
        case 4:
          return (
            <div className='MainDiv' >
              <div>
                <div className='QuestDiv'>
                  <h1>Brauchen Sie einen Kiesstreifen?</h1>
                </div>
                <div className='FlexDiv'>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.kiesstreifen = "ja";
                    this.increase();
                  }}>
                    <CardActionArea>
                      <CardContent>
                        <CardMedia
                          component="img"
                          image={kies}
                          alt="Paella dish"
                        />
                        <Typography gutterBottom variant="h5" component="div">
                          Mit Kiesstreifen
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                  <Card sx={{ maxWidth: 345, margin: 2, padding: 4 }} onClick={() => {
                    this.anfrageDto.kiesstreifen = "nein";
                    this.increase();
                  }}>
                    <CardActionArea>
                      <CardContent>
                        <CardMedia
                          component="img"
                          image={okies}
                          alt="Paella dish"
                        />
                        <Typography gutterBottom variant="h5" component="div">
                          Ohne Kiesstreifen
                        </Typography>
                        <Typography variant="body2" color="text.secondary">

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </div>
              </div>
            </div>)
          break;
        case 5:
          return (
            <div className='MainDiv' >
              <div className='QuestDiv'>
                <h1>Fast geschafft! Wir brauchen nur noch Ihre Kontaktdaten</h1>
              </div>
              <form className='WrapForm' onSubmit={() => {
                this.sendEmail();
              }}>
                <Stack spacing={2}>
                  <TextField id="standard-basic" label="Vorname" variant="standard"
                    onChange={e => {
                      this.anfrageDto.vorname = e.target.value;
                    }} />
                  <TextField id="standard-basic" label="Nachname" variant="standard"
                    onChange={(e) => {
                      this.anfrageDto.nachname = e.target.value;
                    }} />
                  <TextField id="standard-basic" label="Email" variant="standard"
                    onChange={(e) => {
                      this.anfrageDto.email = e.target.value;
                    }} />
                  <TextField id="standard-basic" label="Telefonnummer" variant="standard"
                    onChange={(e) => {
                      this.anfrageDto.telefon = e.target.value;
                    }} />
                  <TextField id="standard-basic" label="Postleitzahl" variant="standard"
                    onChange={(e) => {
                      this.anfrageDto.plz = e.target.value;
                    }} />
                  <Button variant="contained" color="success" onClick={() => {
                    this.sendEmail(this.anfrageDto.vorname, this.anfrageDto.nachname, this.anfrageDto.telefon, this.anfrageDto.email, this.anfrageDto.plz, this.anfrageDto.dachform, this.anfrageDto.dachneigung, this.anfrageDto.flachengrosse, this.anfrageDto.entwasserung, this.anfrageDto.kiesstreifen);
                    this.increase();
                  }}>absenden</Button>
                  {/* <Button class="btnBack"variant="contained" onClick={() => {
                    this.decrease();
                  }}>Zurück</Button> */}
                </Stack>
              </form>
             
            </div>)
          break;
        case 6:
          return (
            <div className='QuestDiv'>
              <h1>Vielen Dank, wir melden uns in den nächsten 48h bei Ihnen.</h1>

            </div>)
          break;
        default:
          break;
      }
    }
    return (
      <div>{getForm(this.state.count)}</div>
    )
  }
}


export default Funnel;
